import { useFamilyIndexByBrand } from "queries/family";
import { getActiveGridId, useShopGridShow } from "queries/shop_grid";
import { useParams } from "react-router-dom";
import ShopInventoryProposal from "./ShopInventoryProposal";
import { useShopShow } from "queries/shops";
import ShopInventoryProposalComparator from "./ShopInventoryProposalComparator";
import useShopIPComparator from "./useShopIPComparator";
import { useEffect } from "react";
import BreadCrumbShop from "../index/BreadCrumbShop";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ShopInventoryComparator = () => {
    const { t } = useTranslation();
    const { erpId } = useParams<{ erpId: string; }>();
    const { data: shop, isFetching } = useShopShow(erpId!);

    let activeGridId = shop ? getActiveGridId(shop!) : undefined;
    let proposalId = shop && shop.shopGrids ? shop?.shopGrids.find(grid => grid.id !== activeGridId)?.id : undefined;

    const { shopIPComparator, setShopIPComparator } = useShopIPComparator(activeGridId, proposalId);
    const { data: activeGrid, isLoading: isLoadingGrid } = useShopGridShow(shopIPComparator.sourceId);
    const { data: gridProposal, isLoading: isLoadingProposal } = useShopGridShow(shopIPComparator.targetId);
    const { data: families = [], isFetching: isFetchingFamilies } = useFamilyIndexByBrand(shop?.brandId);

    useEffect(() => {
        if (shop && !shopIPComparator.sourceId) {
            let activeGridId = shop ? getActiveGridId(shop!) : undefined;
            let proposalId = shop && shop.shopGrids ? shop?.shopGrids.find(grid => grid.id !== activeGridId)?.id : undefined;
            setShopIPComparator({ targetId: proposalId, sourceId: activeGridId })
        }
    }, [shop, shopIPComparator, setShopIPComparator]);

    if (isFetching || isLoadingGrid || isFetchingFamilies || isLoadingProposal) return null;

    return (
        <>
            <Typography component="h1" variant="h6" sx={{ mb: 1 }}>
                {t("shop.index.compare")}
            </Typography>
            <BreadCrumbShop shop={shop} label="shop.index.compare" />
            <ShopInventoryProposalComparator shop={shop!} shopIPComparator={shopIPComparator} setShopIPComparator={setShopIPComparator} />
            {activeGrid && (
                <ShopInventoryProposal
                    activeGrid={activeGrid!}
                    families={families}
                    gridProposal={gridProposal!}
                    disableCellEdition
                    comparatorCellEdition
                />
            )}
        </>
    );
};

export default ShopInventoryComparator;
